import {
  onMounted,
  ref,
  type Ref,
} from "vue";

export type UsePresentingElementReturn = {
  presentingElement: Ref<HTMLIonRouterOutletElement | null>,
};

export function usePresentingElement(
): UsePresentingElementReturn {
  const presentingElement = ref<HTMLIonRouterOutletElement | null>(null)
  // noinspection TypeScriptUnresolvedReference
  onMounted(() => {
    const elem = document.querySelector("ion-router-outlet");
    presentingElement.value = elem ?? null;
  });

  return {
    presentingElement,
  };
}
